// assets
import { IconHeart } from '@tabler/icons-react';
import { t } from 'i18next';
import { ReactComponent as IconHome } from 'assets/images/icons/Branco/icon_home.svg';
import { ReactComponent as IconUsers } from 'assets/images/icons/Branco/Icones_Branco-03.svg';
import { ReactComponent as IconAdmin } from 'assets/images/icons/icon_admin.svg';
import { ReactComponent as IconGroup } from 'assets/images/icons/icon_users.svg';
import { ReactComponent as IconMyGroup } from 'assets/images/icons/Branco/Icones_Branco-09.svg';
import { ReactComponent as IconPlan } from 'assets/images/icons/Branco/Icones_Branco-10.svg';
import { ReactComponent as IconSchedule } from 'assets/images/icons/icon_schedule.svg';
import { ReactComponent as IconForm } from 'assets/images/icons/icon_forms.svg';
import { ReactComponent as IconChat } from 'assets/images/icons/Branco/Icones_Branco-12.svg';
import { ReactComponent as IconLearing } from 'assets/images/icons/By CAC/Icones_cac_06_branco.svg';
import { ReactComponent as IconQuestionaires } from 'assets/images/icons/By CAC/Icones_cac_04_branco.svg';
import { ReactComponent as IconNutrition } from 'assets/images/icons/By CAC/Icones_cac_05_branco.svg';

// constant

// Constant for icons
const icons = {
    IconHome,
    IconAdmin,
    IconUsers,
    IconPlan,
    IconGroup,
    IconMyGroup,
    IconSchedule,
    IconForm,
    IconHeart,
    IconChat,
    IconLearing,
    IconQuestionaires,
    IconNutrition
};

const getMenuItemsForRole = (role) => {
    switch (role) {
        case 'DOCTOR':
            return [
                {
                    type: 'divider'
                },

                {
                    id: 'agenda',
                    title: t('pages.calendar'),
                    key: 'pages.agenda',
                    type: 'item',
                    icon: icons.IconSchedule,
                    url: '/agenda',
                    breadcrumbs: false,
                    disabled: false
                },
                {
                    id: 'users-group',
                    title: t('pages.users'),
                    type: 'collapse',
                    icon: icons.IconUsers,
                    children: [
                        {
                            id: 'utilizadores',
                            title: t('pages.members'),
                            type: 'item',
                            icon: icons.IconUsers,
                            url: '/users'
                        },
                        {
                            id: 'grupos',
                            title: t('pages.groups'),
                            type: 'item',
                            icon: icons.IconGroup,
                            url: '/grupos'
                        },
                        {
                            id: 'meusgrupos',
                            title: t('pages.myGroups'),
                            type: 'item',
                            icon: icons.IconMyGroup,
                            url: '/meusgrupos'
                        }
                    ]
                },
                {
                    id: 'health',
                    title: t('pages.plans'),
                    type: 'collapse',
                    icon: icons.IconPlan,
                    children: [
                        {
                            id: 'planos',
                            title: t('pages.train'),
                            type: 'item',
                            icon: icons.IconPlan,
                            url: '/planos',
                            breadcrumbs: false
                        },
                        {
                            id: 'nutricao',
                            title: t('pages.nutrition'),
                            type: 'item',
                            icon: icons.IconNutrition,
                            url: '/nutricao',
                            breadcrumbs: false
                        }
                    ]
                },
                {
                    id: 'messages',
                    title: t('pages.messages'),
                    key: 'pages.messages',
                    type: 'item',
                    icon: icons.IconChat,
                    url: '/mensagens',
                    breadcrumbs: false,
                    disabled: false
                },
                {
                    id: 'questionarios',
                    title: t('pages.questionnaires'),
                    key: 'pages.questionarios',
                    type: 'item',
                    icon: icons.IconQuestionaires,
                    url: '/questionarios',
                    breadcrumbs: false,
                    disabled: false
                },
                {
                    id: 'aprender',
                    title: t('pages.learn'),
                    key: 'pages.aprender',
                    type: 'item',
                    icon: icons.IconLearing,
                    url: '/aprender',
                    breadcrumbs: false,
                    disabled: false
                },
                {
                    id: 'documentacao',
                    title: t('pages.docs'),
                    key: 'pages.documentacao',
                    type: 'item',
                    icon: icons.IconForm,
                    url: '/documentacao',
                    breadcrumbs: false,
                    disabled: false
                }
            ];

        case 'PATIENT':
            return [
                {
                    id: 'meu-coracao',
                    title: 'O MEU CORAÇÃO',
                    key: 'pages.meu-coracao',
                    type: 'item',
                    icon: icons.IconHeart,
                    url: '/clientSinais',
                    breadcrumbs: false
                },
                {
                    id: 'meu-plano',
                    title: 'O MEU PLANO',
                    key: 'pages.planos',
                    type: 'item',
                    icon: icons.IconPlan,
                    url: '/planos',
                    breadcrumbs: false
                },
                {
                    id: 'questionarios',
                    title: 'QUESTIONÁRIOS',
                    key: 'pages.questionarios',
                    type: 'item',
                    icon: icons.IconForm,
                    url: '/questionarios/paciente',
                    breadcrumbs: false
                },
                {
                    id: 'atividade',
                    title: 'ATIVIDADE',
                    key: 'pages.atividade',
                    type: 'item',
                    icon: icons.IconPlan,
                    url: '/atividade',
                    breadcrumbs: false,
                    disabled: true
                },
                {
                    id: 'minha-clinica',
                    title: 'A MINHA CLINICA',
                    key: 'pages.minha-clinica',
                    type: 'item',
                    icon: icons.IconUsers,
                    url: '/minha-clinica',
                    breadcrumbs: false,
                    disabled: true
                },
                {
                    id: 'conselhos',
                    title: 'CONSELHOS',
                    key: 'pages.conselhos',
                    type: 'item',
                    icon: icons.IconSchedule,
                    url: '/conselhos',
                    breadcrumbs: false,
                    disabled: true
                },
                {
                    id: 'historico',
                    title: 'HISTÓRICO',
                    key: 'pages.historico',
                    type: 'item',
                    icon: icons.IconAdmin,
                    url: '/historico',
                    breadcrumbs: false,
                    disabled: true
                },
                {
                    id: 'atualizar-dados',
                    title: 'ATUALIZAR DADOS',
                    key: 'pages.atualizar-dados',
                    type: 'item',
                    icon: icons.IconUsers,
                    url: '/atualizar-dados',
                    breadcrumbs: false,
                    disabled: true
                },
                {
                    id: 'dispositivo',
                    title: 'DISPOSITIVO',
                    key: 'pages.dispositivo',
                    type: 'item',
                    icon: icons.IconForm,
                    url: '/dispositivo',
                    breadcrumbs: false,
                    disabled: true
                },
                {
                    id: 'sintomas',
                    title: 'SINTOMAS',
                    key: 'pages.sintomas',
                    type: 'item',
                    icon: icons.IconSchedule,
                    url: '/sintomas',
                    breadcrumbs: false,
                    disabled: true
                },
                {
                    id: 'sos',
                    title: 'SOS',
                    key: 'pages.sos',
                    type: 'item',
                    icon: icons.IconSchedule,
                    url: '/sos',
                    breadcrumbs: false,
                    disabled: true
                }
            ];
        default:
            return [];
    }
};

export { getMenuItemsForRole, icons };
